import { IMenuOption } from "../models";
import { environment } from "src/environments/environment";

export enum ALERTS {
    success = 1,
    error = 2,
    warning = 3,
    info = 4,
}

export enum TEMPLATES {
  FIDEICOMISO = "FIDEICOMISO",
  HIPOTECA = "HIPOTECA",
  PRENDAS = "PRENDAS"
}

export class Constants {
    static API_URL: string = environment.ApiUrl;

    public static FILTER_PAG_REGEX = /[^0-9]/g;
    public static FILTER_DAY_REGEX = /[^0-9]/g;
    
    public static get GetMenu(): IMenuOption[] { return this.MENU };

    public static COLONS: string = 'COLONES';
    public static DOLARS: string = 'DÓLARES';

    public static Monedas: string[] = [
      Constants.COLONS, Constants.DOLARS
    ];

    public static Provincias: {id: number, value: string}[] = [
      {id: 1, value: 'San José'},
      {id: 2, value: 'Alajuela'},
      {id: 3, value: 'Cartago'},
      {id: 4, value: 'Heredia'},
      {id: 5, value: 'Guanacaste'},
      {id: 6, value: 'Puntarenas'},
      {id: 7, value: 'Limón'},
    ];

    public static Duplicados: string[] = [
      'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'
    ];

    public static Horizontales: string[] = [
      'F','M'
    ];

    public static CantidadEstadosCiviles: string[] = [
      '','una vez', 'dos veces', 'tres veces', 'cuatro veces', 'cinco veces'
    ];

    public static TiposIdentificacion: string[] = [
      'cédula de identidad','pasaporte', 'residencia'
    ];

    public static Genders: {[id: string] : string } = {
      SM: 'Masculino',
      SF: 'Femenino',
      PM: 'Plural Masculino',
      PF: 'Plural Femenino'
    };

    public static GradosHipoteca: string[] = [
      "PRIMER",
      "SEGUNDO",
      "TERCER",
      "CUARTO"
    ];

    public static GradosPrendas: string[] = [
      "PRIMER",
      "SEGUNDO",
      "TERCER",
      "CUARTO"
    ];

    public static Months: {[id: number] : string } = {
      0: "ENERO",
      1: "FEBRERO",
      2: "MARZO",
      3: "ABRIL",
      4: "MAYO",
      5: "JUNIO",
      6: "JULIO",
      7: "AGOSTO",
      8: "SETIEMBRE",
      9: "OCTUBRE",
      10: "NOVIEMBRE",
      11: "DICIEMBRE"
    }
    
    private static MENU = [
        {
          Name: 'Inicio',
          Route: '/home',
          Icon: 'home',
          Children: [],
          Selected: true,
          Type: 1,
          RequiredPerm: 'V_Home',
          Visible: true
        },
        {
          Name: 'Formatos Legales',
          Route: '',
          Icon: 'file',
          Children: [
            {
              Name: 'Completar formatos',
              Route: '/legal-templates',
              Icon: 'file',
              Children: [],
              Selected: false,
              Type: 2,
              RequiredPerm: 'V_Temp',
              Visible: true
            },
            {
              Name: 'Editar formatos',
              Route: '/view-templates',
              Icon: 'file',
              Children: [],
              Selected: false,
              Type: 2,
              RequiredPerm: 'V_Edt_For', 
              Visible: true
            }
          ],
          Selected: false,
          Type: 1,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Crediserver',
          Route: '',
          Icon: 'users',
          Children: [
            {
              Name: 'General',
              Route: '/general',
              Icon: 'sliders-h',
              Children: [],
              Selected: false,
              Type: 2,
              RequiredPerm: 'V_Crds_Conf', 
              Visible: true
            },
            {
              Name: 'Personas',
              Route: '/people',
              Icon: 'file',
              Children: [],
              Selected: false,
              Type: 2,
              RequiredPerm: 'V_Ppl',
              Visible: true
            },
            {
              Name: 'Cédulas',
              Route: '/person-cards',
              Icon: 'file',
              Children: [],
              Selected: false,
              Type: 2,
              RequiredPerm: 'V_Crds', 
              Visible: true
            }
          ],
          Selected: false,
          Type: 1,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Configuraciones',
          Route: '',
          Icon: 'sliders-h',
          Children: [
            {
              Name: 'Usuarios',
              Route: '/users',
              Icon: 'cogs',
              Children: [],
              Selected: false,
              Type: 2,
              RequiredPerm: 'V_Users',
              Visible: true
            },
            {
              Name: 'Asignaciones',
              Route: '/assignments',
              Icon: 'key',
              Children: [],
              Selected: false,
              Type: 2,
              RequiredPerm: 'V_Assg', 
              Visible: true
            }
          ],
          Selected: false,
          Type: 1,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Salir',
          Route: '/logout',
          Icon: 'sign-out-alt',
          Children: [],
          Selected: false,
          Type: 1,
          RequiredPerm: '',
          Visible: true
        },
    ];
}
